export function times<T>(length: number, callback: (i: number) => T): T[] {
  let result: T[] = [];
  for (let i = 0; i < length; i = i + 1) {
    result.push(callback(i));
  }
  return result;
}
